<script>
	import configuration from '../configuration.json';
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';

    import Section from '../components/Section.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';
    import Back from '../components/Back.svelte';
    import Appointment from '../components/Confirm/Appointment.svelte';
    import Waitlist from '../components/Confirm/Waitlist.svelte';
    import Legal from '../components/Legal.svelte';

    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';


    const current = 'confirm';

    function goBack() {
        replace(previous(current), 'left');
    }

    function goNext() {
        goto(next(current), 'right');
    }


    onMount(() => {
        const requiredFields = ['treatment', 'employee', 'date', 'time', 'customer'];
        const missingFields = [];

        for (const field of requiredFields) {
            if (!currentSession[field]) {
                missingFields.push(field);
            }
        }

        if (missingFields.length > 0) {
            replace('error/incomplete');
        }
    });

    let termsAndConditionsUrl = $derived(app.settings.terms.conditions || app.salon.website);

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('is_this_correct')}</title>
</svelte:head>

<Section title={$_('is_this_correct')}>
    {#snippet back()}
        <Back onclick={goBack} />
    {/snippet}

    {#if currentSession.type === 'waitlist'}
        <p>
            {$_('waitlist_confirm_details')}
        </p>

        <Waitlist appointment={currentSession} />
    {:else}
        <p>
            {$_('confirm_details')}
        </p>

        <Appointment appointment={currentSession} />
    {/if}

    <Legal>
        <p>
            {@html $_('terms_consent', { values: { url: termsAndConditionsUrl } })}
        </p>

        {#if currentSession.type === 'waitlist'}
            <p>
                {$_('waitlist_no_confirmation')}
            </p>
        {/if}

        {#if currentSession.type === 'appointment' && app.settings.cancel.warning}
            <p>
                {$_('cancellation_warning')}
            </p>
        {/if}
    </Legal>

    {#snippet navigation()}
        <Navigation>
            <Button color="accent" onclick={goNext}>
                {#if currentSession.type === 'waitlist'}
                    {$_('waitlist_confirm_button')}
                {:else}
                    {$_('book')}
                {/if}
                <Icon data={arrowRightIcon} />
            </Button>
        </Navigation>
    {/snippet}
</Section>